import Accordion, { AccordionProps } from "@mui/material/Accordion";
import { EmtAccordionSummary } from "./EmtAccordionSummary";
import { EmtAccordionDetails } from "./EmtAccordionDetails";
import Box from "@mui/material/Box";
import { styled, SxProps } from "@mui/material/styles";
import { EmtTheme } from "../types";

export type EmtAccordionProps = AccordionProps & {
  title: string;
  nonce?: string;
};

const StyledAccordion = styled(Accordion)(
  ({ theme }: { theme?: EmtTheme }) => ({
    borderBottom: `1px solid ${theme?.palette.divider}`,
    "&:is(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
  })
);

const accordionWrapperStyle: SxProps = {
  display: "flex",
  flexDirection: "column",
  rowGap: "15px",
};

export function EmtAccordion(props: EmtAccordionProps) {
  const {
    title,
    disableGutters = true,
    elevation = 0,
    children,
    onClick,
    ...rest
  } = props;
  return (
    <>
      <StyledAccordion
        disableGutters={disableGutters}
        elevation={elevation}
        {...rest}
      >
        <EmtAccordionSummary title={title} onClick={onClick} />
        <EmtAccordionDetails>
          <Box sx={accordionWrapperStyle}>{children}</Box>
        </EmtAccordionDetails>
      </StyledAccordion>
    </>
  );
}
